<template>
    <div class="doc-group-block">
        <div class="doc-group-header" @click="expanded = !expanded">
            <button class="doc-group-toggle" type="button">
                {{ expanded ? '▾' : '▸' }}
            </button>

            <div class="doc-group-title">
                {{ grupo.nmcaption }}
            </div>

            <div v-if="opcoes.length" class="doc-group-options-header">
                <span
                    v-for="opcao in opcoes"
                    :key="opcao"
                    class="doc-group-option-label"
                >
                    {{ opcao }}
                </span>
            </div>
        </div>

        <div v-show="expanded" class="doc-group-body">
            <template v-for="item in itensOrdenados" :key="item.id">
                <DocSessionRow
                    v-if="item.tpitem === 'SESSION'"
                    :item="item"
                />

                <DocDynamicItem
                    v-else-if="item.tpitem === 'ITEM'"
                    :item="item"
                    :opcoes-grupo="opcoes"
                    :opcoes-ck-obs-grupo="grupo.opcoes_ckobs"
                    inside-group
                    @update:item="emit('update:item', $event)"
                />
            </template>
        </div>
    </div>
</template>

<script setup>
import { computed, ref } from 'vue';

import DocDynamicItem from './DocDynamicItem.vue';
import DocSessionRow from './DocSessionRow.vue';

const props = defineProps({
    grupo: {
        type: Object,
        required: true
    },
    itens: {
        type: Array,
        default: () => []
    }
});

const emit = defineEmits(['update:item']);

const expanded = ref(true);

const opcoes = computed(() => {
    return props.grupo.opcoes
        ? String(props.grupo.opcoes).split(';').map(op => op.trim()).filter(Boolean)
        : [];
});

const itensOrdenados = computed(() => {
    return [...props.itens].sort((a, b) => {
        const ordemA = Number(a.ordem ?? 0);
        const ordemB = Number(b.ordem ?? 0);

        if (ordemA !== ordemB) return ordemA - ordemB;

        return Number(a.id ?? 0) - Number(b.id ?? 0);
    });
});
</script>

<style scoped>
.doc-group-block {
    margin-top: 12px;
    border: 1px solid #d8e2ec;
    border-radius: 8px;
    overflow: hidden;
    background: #fff;
}

.doc-group-header {
    display: grid;
    grid-template-columns: 28px minmax(0, 1fr) auto;
    align-items: center;
    gap: 8px;

    padding: 9px 10px;
    border-left: 4px solid #2f5f9f;
    background: #f3f6fb;
    cursor: pointer;
}

.doc-group-header:hover {
    background: #eaf0f8;
}

.doc-group-toggle {
    width: 24px;
    height: 24px;
    border: none;
    background: transparent;
    color: #2f5f9f;
    font-size: 18px;
    font-weight: 700;
    cursor: pointer;
    padding: 0;
}

.doc-group-title {
    font-weight: 700;
    color: #1f2937;
    text-align: left;
}

.doc-group-options-header {
    display: grid;
    grid-template-columns: repeat(4, 42px);
    gap: 4px;
}

.doc-group-option-label {
    height: 24px;
    display: flex;
    align-items: center;
    justify-content: center;

    font-size: 12px;
    font-weight: 700;
    color: #374151;

    border: 1px solid #cbd5e1;
    border-radius: 4px;
    background: #fff;
}

.doc-group-body {
    padding: 8px 10px 10px;
}
</style>